/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    p: "p",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Create an API key"
    }), "\n", _jsx(_components.h2, {
      children: "API Keys"
    }), "\n", _jsx(_components.p, {
      children: "Your own credentials should not be used by systems acting on your behalf.\nCreate API keys to enable safe and controlled access by agents."
    }), "\n", _jsx(_components.p, {
      children: "As WebSemaphore develops we are planning to add access policies that will limit the scope of API keys to certain semaphores and operations."
    }), "\n", _jsx(_components.h2, {
      children: "Creating an API key"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "In the top right menu find the \"Services\" dropdown and navigate to \"API Keys\"."
      }), "\n", _jsx(_components.li, {
        children: "Click on \"Create Key\""
      }), "\n", _jsx(_components.li, {
        children: "Fill out a descriptive title for the key, e.g. \"Testkey\""
      }), "\n", _jsx(_components.li, {
        children: "Optionally add a reference id that will help you identify the key owner from an index in another system such as your company CMDB."
      }), "\n", _jsx(_components.li, {
        children: "Click ok"
      }), "\n", _jsx(_components.li, {
        children: "You will be presented with key information. Copy and paste the information into your secrets store. Note that this is the only time this information may be copied."
      }), "\n", _jsx(_components.li, {
        children: "Click and note the key now appears in the list of API keys"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Note the keys are not editable. Once created, they may only be invalidated."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
